import Login from "../components/account/Login";
import Logout from "../components/account/Logout";
import TeacherStudentsMain from "../components/teacher-ui/TeacherStudentsMain";
import Profile from "../components/account/Profile";
import TeacherWelcome from "../components/teacher-ui/TeacherWelcome";


export enum NavPlacement {
    MAIN,
    PROFILE,
    NONE,
}

class TeacherPages {
    pages: TeacherPage[] = []

    constructor() {
        this.pages = [
            new TeacherPage("Oppilaat", "/teacher/students", <TeacherStudentsMain />, [NavPlacement.MAIN]),
            new TeacherPage("Profiili", "/teacher/profile", <Profile />, [NavPlacement.PROFILE]),
            new TeacherPage("Kirjaudu ulos", "/teacher/logout", <Logout />, [NavPlacement.PROFILE]),
            new TeacherPage("Kirjaudu", "/login", <Login />),
            new TeacherPage("Tervetuloa", "/teacher/", <TeacherWelcome/>, [NavPlacement.MAIN]),
        ]
    }

    getByPlacement(placement: NavPlacement) {
        return this.pages.filter(page => {
            return page.navPlacements.includes(placement)
        });
    }
}

class TeacherPage {
    name: string = "";
    path: string = "";
    content: JSX.Element = <></>;
    navPlacements: NavPlacement[] = []

    constructor(name: string, path: string, content: JSX.Element, navPlacements: NavPlacement[] = []) {
        this.name = name;
        this.path = path;
        this.content = content;
        this.navPlacements = navPlacements;
    }
}

export default TeacherPages;